import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";

const Chapter = ({ gid, num }) => {
  const [html, setHtml] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    setHtml(null);
    setErr("");
    api.get(`/relocation/guides/${gid}/chapters/${num}`).then((r) => setHtml(r.data.html)).catch((e) => setErr(errMsg(e)));
  }, [gid, num]);
  if (err) return <p className="text-sm text-red-700">{err}</p>;
  if (html === null) return <p className="eyebrow">Loading chapter…</p>;
  return <div className="prose-guide" data-testid="reloc-chapter-content" dangerouslySetInnerHTML={{ __html: html }} />;
};

export const VolumeReader = ({ gid, volumes }) => {
  const [vi, setVi] = useState(0);
  const vol = volumes[vi];
  const first = vol?.parts?.[0]?.chapters?.[0];
  const [num, setNum] = useState(first?.num);
  const all = volumes.flatMap((v) => v.parts.flatMap((p) => p.chapters));
  const ch = all.find((c) => c.num === num);
  if (!vol) return <p className="text-[#8C827A]">No chapters copied yet.</p>;

  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-8">
        {volumes.map((v, i) => (
          <button key={v.num} data-testid={`reloc-volume-${v.num}`} onClick={() => { setVi(i); setNum(v.parts[0]?.chapters[0]?.num); }}
            className={`px-4 py-2 text-sm border transition-colors ${i === vi ? "bg-[#3B1B48] text-[#FAF7F2] border-[#3B1B48]" : "border-[#E2D9CC] text-[#3B1B48] hover:bg-[#EFE6F3]"}`}>
            Volume {v.roman} · {v.name}
          </button>
        ))}
      </div>
      <div className="grid lg:grid-cols-[320px_1fr] gap-10">
        <nav className="space-y-6 lg:sticky lg:top-8 self-start max-h-[75vh] overflow-auto" data-testid="reloc-chapter-nav">
          {vol.parts.map((p) => (
            <div key={p.title}>
              <p className="eyebrow mb-2">{p.title}</p>
              {p.chapters.map((c) => (
                <button key={c.num} data-testid={`reloc-chapter-${c.num}`} onClick={() => setNum(c.num)}
                  className={`w-full text-left flex gap-3 px-3 py-2 text-sm transition-colors ${c.num === num ? "bg-[#3B1B48] text-[#FAF7F2]" : "text-[#1C181D] hover:bg-[#EFE6F3]"}`}>
                  <span className="font-display text-[#C59B27] w-6 shrink-0">{c.num}</span><span>{c.title}</span>
                </button>
              ))}
            </div>
          ))}
        </nav>
        <article className="max-w-3xl rise" key={num}>
          <div className="bg-[#3B1B48] text-[#FAF7F2] px-10 py-10 mb-8">
            <p className="eyebrow">Volume {vol.roman} · Chapter {num}</p>
            <h2 className="font-display text-3xl lg:text-4xl mt-3" data-testid="reloc-chapter-title">{ch?.title}</h2>
            {ch?.synopsis && <p className="font-display italic text-[#EFE6F3] mt-3">{ch.synopsis}</p>}
          </div>
          {num && <Chapter gid={gid} num={num} />}
        </article>
      </div>
    </div>
  );
};
